module.exports = __webpack_public_path__ + "media/images/invitations_header-illustration-694b76ee.svg";